import Phaser from 'phaser';

/** Tiny pre-preload scene: just hands off to PreloadScene immediately. */
export class BootScene extends Phaser.Scene {
  constructor() {
    super('Boot');
  }

  create() {
    this.scene.start('Preload');
  }
}
